export default __webpack_public_path__ + "static/SFMono-RegularItalic-3a20a00dfdeb4ba538473fa7bf625cbd.woff";